import { datalayerEvent } from './dataLayer.js';
console.log("product.js loaded");

const html = document.documentElement;
const body = document.body; 

let originalPageTitle, colourRadios, sizeAndQuantitySelectors, selectedColourId, selectedColourName;

let deliveryBasketState = { count: 0, totalExVat: 0, totalIncVat: 0 };
let suppressDeliveryMessageUpdate = false;
let basketProductQty = 0;

//grab product data json via ajax

let productJsonPromise = null;
let productJSON = null;

function loadProductJson(product_id)
{
    if (!productJsonPromise)
    {
        productJsonPromise = fetch("/json/product/"+product_id)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                console.log('Product JSON Loaded');
                return data;
            });
    }
    return productJsonPromise; // Return the promise for future access
}

// Wait for the JSON to load
async function readProductJson()
{
    if (html.dataset.product_id)
    {
        const data = await loadProductJson(html.dataset.product_id);
        return data;
    }
    return false;
}

//product images

import Swiper from 'swiper';
import { Zoom, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import "swiper/css/zoom";

var product_images_swiper;

async function repopulateSwiper(colourId)
{
    const product_images_container = document.querySelector(".product_images_container");
    const product_images_swiper_wrapper = product_images_container.querySelector(".swiper-wrapper");
    const thumbnail = document.querySelector("#sticky_add_to_basket_thumb_container img");
    let html = "";
    let thumbnail_url = "";

    product_images_container.setAttribute("data-colour-id",colourId);
    product_images_container.classList.add("loading");

    let product_json = await readProductJson();

    if (product_json)
    {
        if (product_json.hasOwnProperty("colours"))
        {
            product_json.colours.forEach(colour => {
                if (colour.id == colourId)
                {
                    if (colour.hasOwnProperty("images"))
                    {
                        if (colour.images.hasOwnProperty("main"))
                        {
                            html += buildImageSlide(colour.images.main);
                        }

                        if (colour.images.hasOwnProperty("thumbnail"))
                        {
                            thumbnail_url = colour.images.thumbnail.url;
                        }

                        if (colour.images.hasOwnProperty("alternatives"))
                        {
                            colour.images.alternatives.forEach(image => 
                            {
                                html += buildImageSlide(image);
                            });
                        }
                    }
                }
            });
        }
    }


    if (product_images_swiper instanceof Swiper)
    {
        product_images_swiper.destroy();
    }
    
    product_images_swiper_wrapper.innerHTML = html;
    initialiseSwiper();
    product_images_container.classList.remove("loading");
    
    if (thumbnail_url == "")
    {
        thumbnail.classList.add("hidden");
    }
    else
    {
        thumbnail.classList.remove("hidden");
    }
    thumbnail.setAttribute("src",thumbnail_url);

    // Keep the sticky thumbnail's alt in step with the main slider (product name - colour).
    // Use document.documentElement here, not the module-scoped `html` const, because the local
    // `let html` above shadows it within this function.
    let thumbAlt = "";
    if (document.documentElement.dataset.product_name)
    {
        thumbAlt = document.documentElement.dataset.product_name;
    }
    if (selectedColourName)
    {
        if (thumbAlt != "")
        {
            thumbAlt += " - ";
        }
        thumbAlt += window.stripTags(selectedColourName);
    }
    thumbnail.setAttribute("alt", thumbAlt);

}

function initialiseSwiper()
{
    const product_images_container = document.querySelector(".product_images_container");
    const product_images_swiper_wrapper = product_images_container.querySelector(".swiper-wrapper");
    const swiperZoomButton = document.querySelector(".swiper_zoom_button");

    if (product_images_swiper instanceof Swiper)
    {
        product_images_swiper.destroy();
    }
    
    const allSwiperImages = product_images_swiper_wrapper.querySelectorAll("img");

    if (allSwiperImages.length)
    {
        allSwiperImages.forEach(swiperImage =>
        {
            swiperImage.dataset.regular_src = swiperImage.getAttribute("src");
            if (!swiperImage.dataset.zoom_src)
            {
                swiperImage.dataset.zoom_src = swiperImage.getAttribute("src");
            }
        });
        
        product_images_swiper = new Swiper('.product_images_swiper', {
            modules: [Zoom, Navigation, Pagination],
            direction: 'horizontal',
            loop: false,
            zoom: true,
            slidesPerView: 1,
        
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
                },
                pagination: {
                el: ".swiper-pagination",
                clickable: true,
                },
        });
        
        
        
        swiperZoomButton.removeEventListener('click', zoomButtonClicked); //prevent duplicate listener
        swiperZoomButton.addEventListener('click',zoomButtonClicked);
        
        product_images_swiper.on('zoomChange',(product_images_swiper) =>
        {
            const activeSlide = product_images_swiper.slides[product_images_swiper.activeIndex];
            const activeImg = activeSlide.querySelector('img');
            const isZoomed = product_images_swiper.zoom.scale > 1; // Scale > 1 means zoomed
            if (isZoomed)
            {
                swiperZoomButton.classList.remove('zoomed');
                activeImg.setAttribute('src', activeImg.dataset.regular_src);
            }
            else
            {
                swiperZoomButton.classList.add('zoomed');
                activeImg.setAttribute('src', activeImg.dataset.zoom_src);
            }
        });
    }
    else
    {

    }

}

function zoomButtonClicked()
{
    if (product_images_swiper.zoom.enabled)
    {
        product_images_swiper.zoom.toggle();
    }
}


async function changeSelectedColour(colourId, forceRefresh = false, initialPageLoad = false, callback = false)
{
    console.log("Changing colour ID to "+colourId);
    
    let colourAnchor,sizeAnchor;
    [colourAnchor, sizeAnchor] = getColourAnchorAndSizeAnchor();

    const colourRadio = document.querySelector(`.colour_selector_choices .colour_swatch[value="${colourId}"]`);
    if (colourRadio)
    {
        const colourRadioLabel = colourRadio.nextElementSibling;
        const currentScrollY = window.scrollY;
        colourRadio.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
        });
        window.scrollTo({ top: currentScrollY });
        const selectedColourLabel = document.querySelector("#sticky_add_to_basket_summary .selected_colour");
        selectedColourLabel.innerHTML = colourRadioLabel.innerHTML;
        selectedColourName = colourRadioLabel.innerHTML;

        const newColourName = colourRadio.closest("label").getAttribute("title");
        const newColourAnchor = colourRadio.getAttribute("data-anchor");

        //if the colour is being changed or we're forcing a refresh...
        if (colourId != selectedColourId || forceRefresh)
        {
            if (newColourAnchor && !initialPageLoad)
            {
                document.title = window.stripTags(newColourName)+" "+originalPageTitle;
                
                //if the window.location.hash doesn't contain the colour, change it
                if (colourAnchor!=newColourAnchor)
                {
                    window.location.hash = newColourAnchor;
                }
            }
            selectedColourId = colourId;
            buildAvailableSizesAndQuantitiesHTML(colourId).then(html =>
            {
                sizeAndQuantitySelectors.innerHTML = html;
                fitSizeLabels();
                if (typeof callback === 'function')
                {
                    callback();
                }
                updateStickyAddToBasket();
            });
            clearActivePriceBreak();
        }
        //if the image needs changing...
        if (colourId != document.querySelector(".product_images_container").getAttribute("data-colour-id"))
        {
            repopulateSwiper(colourId);
        }

    }
}

async function buildAvailableSizesAndQuantitiesHTML(colourId)
{
    console.log("Building available sizes and quantities for "+colourId);
    let html = "";
    let product_json = await readProductJson();
    if (product_json && product_json.hasOwnProperty("colours"))
    {
        product_json.colours.forEach(colour => {
            if (colour.id == colourId)
            {
                //console.log("found",colour.name);
                if (colour.hasOwnProperty("sizes"))
                {
                    colour.sizes.forEach(size => 
                    {
                        html+=buildSizeQuantitySelector(size,(colour.sizes.length==1));
                    });
                }
                //console.log(colour.sizes);
            }
        });
    }
    if (html=="")
    {
        html = "<p class=\"red_text\">Sorry, there are no sizes available for your chosen colour.</p>";
    }
    return html;
}

function buildImageSlide(image)
{
    const template = document.querySelector("#templates .product_image_slide");
    let newImageSelector = template.cloneNode(true);
    let img = newImageSelector.querySelector("img");

    if (image.hasOwnProperty("url") && image.url)
    {
        img.setAttribute("src",image.url);
    }
    if (image.hasOwnProperty("zoom_url") && image.zoom_url)
    {
        img.dataset.zoom_src = image.zoom_url;
    }
    else
    {
        img.removeAttribute("data-zoom_src");
    }
    let alt = "";
    if (image.hasOwnProperty("alt") && image.alt)
    {
        alt = image.alt;
    }
    if (html.dataset.product_name)
    {
        if (alt!="")
        {
            alt+=" - ";
        }
        alt+=html.dataset.product_name;
    }
    if (selectedColourName)
    {
        if (alt!="")
        {
            alt+=" - ";
        }
        alt+=window.stripTags(selectedColourName);
    }
    img.setAttribute("alt",alt);

    return newImageSelector.outerHTML;
}

function buildSizeQuantitySelector(size, onlyVariant = false)
{
    const template = document.querySelector("#templates .size_quantity_selector");
    let newSelector = template.cloneNode(true);
    let label = newSelector.querySelector("label.size");
    let quantitySelector = newSelector.querySelector(".quantity_selector");
    let input = quantitySelector.querySelector("input[type=number]");
    let footerSlot = newSelector.querySelector(".footer_slot");
    let alternatives_link = newSelector.querySelector(".alternatives_link");

    let id ="size_qty_selector_"+size.variant_id;
    label.setAttribute("for",id);
    if (onlyVariant && size.name.trim()=="")
    {
        size.name="One Size";
    }
    else if (size.name.trim()=="")
    {
        size.name="&nbsp;";
    }
    label.innerHTML = '<span>' + size.name + '</span>';
    input.id = id;
    input.setAttribute("name",size.variant_id);
    input.setAttribute("max",size.max);
    input.setAttribute("data-anchor",size.anchor);


    return newSelector.outerHTML;
}

function getActivePriceBreak(quantity)
{
    const effectiveQuantity = quantity + basketProductQty;
    const allPriceBreaks = document.querySelectorAll(".price_break_list li:not(.hidden)");
    let activePriceBreak = false;
    allPriceBreaks.forEach(priceBreak => {
        const min = priceBreak.getAttribute("data-min");
        const max = priceBreak.getAttribute("data-max");
        if (max && effectiveQuantity > max)
        {
            return; //skip
        }
        if (effectiveQuantity >= min)
        {
            activePriceBreak = priceBreak;
        }
    });
    return activePriceBreak;
}

function updateLastVisibleBreakClass()
{
    const allPriceBreaks = document.querySelectorAll(".price_break_list li");
    allPriceBreaks.forEach(li => li.classList.remove("last-visible"));
    const visibleBreaks = document.querySelectorAll(".price_break_list li:not(.hidden)");
    if (visibleBreaks.length > 0) {
        visibleBreaks[visibleBreaks.length - 1].classList.add("last-visible");
    }
}

function clearActivePriceBreak()
{
    const allPriceBreaks = document.querySelectorAll(".price_break_list li:not(.hidden)");
    if (allPriceBreaks.length > 0)
    {
        setActivePriceBreak(getActivePriceBreak(0) || allPriceBreaks[0]);
    }
}

function setActivePriceBreak(priceBreak)
{
    const allPriceBreaks = document.querySelectorAll(".price_break_list li:not(.hidden)");
    if (allPriceBreaks.length > 0)
    {
        allPriceBreaks.forEach(priceBreak => {
            priceBreak.classList.remove("active");
        });
        priceBreak.classList.add("active");
        const currentScrollY = window.scrollY;
            priceBreak.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center'
        });
        window.scrollTo({ top: currentScrollY });
    }
}

function calculateTotalFromPriceBreaks(quantity)
{
    const activePriceBreak = getActivePriceBreak(quantity);
    if (activePriceBreak)
    {
        setActivePriceBreak(activePriceBreak);
        if (quantity > 0)
        {
            const exVatSpan = activePriceBreak.querySelector(".price .ex_vat_price");
            const incVatSpan = activePriceBreak.querySelector(".price .inc_vat_price");
            const exVatItemCost = exVatSpan.getAttribute("data-raw");
            const incVatItemCost = incVatSpan.getAttribute("data-raw");

            const customisation = activePriceBreak.classList[0];

            return [exVatItemCost * quantity,incVatItemCost * quantity, !!activePriceBreak.querySelector("span.from"), customisation];
        }
    }
    return false;
}

function setDeliveryMessageContent(deliveryMessage, html, animate = true, pulseSelector = null)
{
    // Compare against the last content we set, not the live innerHTML: the
    // pulse class is added to child spans after each set, which would otherwise
    // make an unchanged message look "changed" and pulse repeatedly.
    const changed = deliveryMessage.dataset.currentMessage !== html;
    deliveryMessage.dataset.currentMessage = html;
    deliveryMessage.innerHTML = html;
    deliveryMessage.classList.remove('transparent');
    if (animate && changed) {
        const targets = pulseSelector
            ? [...deliveryMessage.querySelectorAll(pulseSelector)]
            : [deliveryMessage];
        targets.forEach(t => {
            t.classList.remove('pulse');
            void t.offsetWidth;
            t.classList.add('pulse');
        });
    }
}

function updateFreeDeliveryMessage(pendingQty, totalsAndApplicationType, animate = true)
{
    if (suppressDeliveryMessageUpdate) return;

    const deliveryMessage = document.getElementById('product_delivery_message');
    if (!deliveryMessage) return;

    const threshold         = parseFloat(deliveryMessage.dataset.threshold);
    const thresholdIncVat   = parseFloat(deliveryMessage.dataset.thresholdIncVat);
    const basketTotal       = deliveryBasketState.totalExVat;
    const basketTotalIncVat = deliveryBasketState.totalIncVat;
    const basketCount       = deliveryBasketState.count;

    if (!threshold || threshold <= 0) {
        deliveryMessage.classList.remove('transparent');
        return;
    }

    const pendingExVat  = (totalsAndApplicationType && totalsAndApplicationType[0]) ? parseFloat(totalsAndApplicationType[0]) : 0;
    const pendingIncVat = (totalsAndApplicationType && totalsAndApplicationType[1]) ? parseFloat(totalsAndApplicationType[1]) : 0;

    deliveryMessage.classList.remove('approaching');

    if (basketCount === 0 && pendingQty === 0) {
        deliveryMessage.classList.remove('qualified');
        setDeliveryMessageContent(deliveryMessage, deliveryMessage.dataset.defaultMessage, animate);
        return;
    }

    const combinedExVat = basketTotal + pendingExVat;

    if (combinedExVat >= threshold) {
        if (!deliveryMessage.classList.contains('qualified')) {
            // Adding .qualified here only happens on a genuine threshold
            // crossing, because the server renders .qualified into the element
            // when the basket already qualifies on page load. So this is always
            // a real transition and we drive the truck.
            deliveryMessage.classList.remove('drive_truck');
            void deliveryMessage.offsetWidth;
            deliveryMessage.classList.add('qualified', 'drive_truck');
        }
        setDeliveryMessageContent(deliveryMessage, deliveryMessage.dataset.qualifiedMessage, animate);
        return;
    }

    deliveryMessage.classList.remove('qualified');
    const remainingExVat  = Math.max(0, threshold - combinedExVat);
    const remainingIncVat = Math.max(0, thresholdIncVat - (basketTotalIncVat + pendingIncVat));

    deliveryMessage.classList.add('approaching');
    setDeliveryMessageContent(
        deliveryMessage,
        'Spend ' +
        '<span class="ex_vat_price"><span class="ex_vat_value">' + window.displayPrice(remainingExVat) + '</span></span>' +
        '<span class="inc_vat_price"><span class="inc_vat_value">' + window.displayPrice(remainingIncVat) + '</span></span>' +
        ' more for Free Delivery',
        animate,
        '.ex_vat_price, .inc_vat_price'
    );
}

function updatePriceBreakProximityMessage(pendingQty)
{
    const priceBreakList = document.querySelector('.price_break_list');
    if (!priceBreakList) return;

    const allVisibleBreaks = [...document.querySelectorAll('.price_break_list li:not(.hidden)')];

    allVisibleBreaks.forEach(li => {
        const msg = li.querySelector('.price_break_proximity_message');
        if (msg) msg.innerHTML = '';
    });

    if (allVisibleBreaks.length <= 1) return;

    const proximityThreshold = parseInt(priceBreakList.dataset.proximityThreshold) || 3;
    const effectiveQty = pendingQty + basketProductQty;
    const activePriceBreak = getActivePriceBreak(pendingQty);
    if (!activePriceBreak) return;

    const firstBreakExVat = parseFloat(allVisibleBreaks[0].querySelector('.price .ex_vat_price')?.getAttribute('data-raw'));
    if (!firstBreakExVat) return;

    const activeIndex = allVisibleBreaks.indexOf(activePriceBreak);

    const nextBreak = allVisibleBreaks[activeIndex + 1];
    const nextMin = nextBreak ? parseInt(nextBreak.getAttribute('data-min')) : null;
    const remaining = nextMin !== null ? nextMin - effectiveQty : null;
    const approachingNext = remaining !== null && remaining > 0 && remaining <= proximityThreshold;

    if (activeIndex > 0 && !approachingNext) {
        const activeBreakExVat = parseFloat(activePriceBreak.querySelector('.price .ex_vat_price')?.getAttribute('data-raw'));
        if (activeBreakExVat) {
            const savingPct = Math.round((firstBreakExVat - activeBreakExVat) / firstBreakExVat * 100);
            if (savingPct > 0) {
                const msg = activePriceBreak.querySelector('.price_break_proximity_message');
                if (msg) msg.innerHTML = `<span class="icon_text medium_icon white tick">You're saving ${savingPct}%</span>`;
            }
        }
    }

    if (approachingNext) {
        const nextBreakExVat = parseFloat(nextBreak.querySelector('.price .ex_vat_price')?.getAttribute('data-raw'));
        if (nextBreakExVat) {
            const discountPct = Math.round((firstBreakExVat - nextBreakExVat) / firstBreakExVat * 100);
            if (discountPct > 0) {
                const msg = nextBreak.querySelector('.price_break_proximity_message');
                if (msg) msg.innerHTML = `<span class="icon_text medium_icon white warning">Only ${remaining} away from a ${discountPct}% discount</span>`;
            }
        }
    }
}

async function updateStickyAddToBasket()
{
    const quantityFields = sizeAndQuantitySelectors.querySelectorAll(".quantity_selector_quantity_field");
    const stickyAddToBasketPanel = document.getElementById("sticky_add_to_basket_panel");
    const stickyAddToBasketButton = document.getElementById("sticky_add_to_basket_button");
    const stickyAddToBasketQuantity = stickyAddToBasketPanel.querySelector(".total_qty");
    const stickyAddToBasketSingular = stickyAddToBasketPanel.querySelector(".singular");
    const stickyAddToBasketPlural = stickyAddToBasketPanel.querySelector(".plural");
    
    let quantity = 0;
    quantityFields.forEach(input => {
        quantity+=parseInt(input.value);
    });

    stickyAddToBasketQuantity.innerHTML = new Intl.NumberFormat().format(quantity);
    if (quantity==0)
    {
        stickyAddToBasketQuantity.style.display = "none";
        stickyAddToBasketSingular.style.display = "inline";
        stickyAddToBasketPlural.style.display = "none";
    }
    else if (quantity==1)
    {
        stickyAddToBasketQuantity.style.display = "inline";
        stickyAddToBasketSingular.style.display = "inline";
        stickyAddToBasketPlural.style.display = "none";
    }
    else
    {
        stickyAddToBasketQuantity.style.display = "inline";
        stickyAddToBasketSingular.style.display = "none";
        stickyAddToBasketPlural.style.display = "inline";
    }

    const totalsAndApplicationType = calculateTotalFromPriceBreaks(quantity);
    updateFreeDeliveryMessage(quantity, totalsAndApplicationType);
    updatePriceBreakProximityMessage(quantity);
    if (!totalsAndApplicationType)
    {
        stickyAddToBasketPanel.classList.remove("ready");
        stickyAddToBasketButton.disabled = true;
    }
    else
    {
        stickyAddToBasketPanel.classList.add("ready");
        stickyAddToBasketButton.disabled = false;

        const exVatPrice = window.displayPrice(totalsAndApplicationType[0]);
        const incVatPrice = window.displayPrice(totalsAndApplicationType[1]);
        const showFrom = totalsAndApplicationType[2];
        const applicationType = totalsAndApplicationType[3];

        const sticky_add_to_basket_price_and_delivery_estimate = document.getElementById("sticky_add_to_basket_price_and_delivery_estimate");
        if (showFrom)
        {
            sticky_add_to_basket_price_and_delivery_estimate.classList.add("from");
        }
        else
        {
            sticky_add_to_basket_price_and_delivery_estimate.classList.remove("from");
        }

        const classesToRemoveFromStickyAddToBasketPriceAndDeliveryEstimate = ["uncustomised","print","embroidery"];
        classesToRemoveFromStickyAddToBasketPriceAndDeliveryEstimate.forEach(classToRemove =>
        {
            if (classToRemove != applicationType)
            {
                sticky_add_to_basket_price_and_delivery_estimate.classList.remove(classToRemove);
            }
        });
        sticky_add_to_basket_price_and_delivery_estimate.classList.add(applicationType);
        
        stickyAddToBasketPanel.querySelector(".ex_vat_value").innerHTML = exVatPrice;
        stickyAddToBasketPanel.querySelector(".inc_vat_value").innerHTML = incVatPrice;
        if (totalsAndApplicationType[0] >= 1000)
        {
            sticky_add_to_basket_price_and_delivery_estimate.classList.add("long_price");
        }
        else
        {
            sticky_add_to_basket_price_and_delivery_estimate.classList.remove("long_price");
        }
    }
}

function selectSizeByAnchor(sizeAnchor)
{
    const quantityFieldToSelect = sizeAndQuantitySelectors.querySelector(".quantity_selector_quantity_field[data-anchor='"+sizeAnchor+"']");
    if (quantityFieldToSelect)
    {
        quantityFieldToSelect.value =1;
        quantityFieldToSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
}

function getColourAnchorAndSizeAnchor()
{
    const pageAnchor = window.location.hash.substring(1);
    return pageAnchor.split('_');
}

function fitSizeLabels() {
    document.querySelectorAll('.size_quantity_selector label span').forEach(span => {
        const label = span.parentElement;
        span.style.fontSize = '';
        const labelStyle = getComputedStyle(label);
        const availableWidth = label.clientWidth
            - parseFloat(labelStyle.paddingLeft)
            - parseFloat(labelStyle.paddingRight);
        if (span.offsetWidth > availableWidth) {
            span.style.fontSize = (availableWidth / span.offsetWidth) + 'em';
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {

    window.startHeartbeat();

    document.fonts.ready.then(fitSizeLabels);

    let colourAnchor, sizeAnchor;

    originalPageTitle = document.title;

    [colourAnchor, sizeAnchor] = getColourAnchorAndSizeAnchor();

    //colour radios

    colourRadios = document.querySelectorAll(`input.colour_swatch`);
    sizeAndQuantitySelectors = document.querySelector(`.size_and_quantity_selectors`);

    const deliveryMessageEl = document.getElementById('product_delivery_message');
    if (deliveryMessageEl) {
        deliveryBasketState.count       = parseInt(deliveryMessageEl.dataset.basketCount)       || 0;
        deliveryBasketState.totalExVat  = parseFloat(deliveryMessageEl.dataset.basketTotal)     || 0;
        deliveryBasketState.totalIncVat = parseFloat(deliveryMessageEl.dataset.basketTotalIncVat) || 0;
    }

    basketProductQty = parseInt(html.dataset.basketProductQty) || 0;

    //is there an anchor for a colour on page load?
    if (colourAnchor)
    {
        const anchorColourRadio = document.querySelector("input.colour_swatch[data-anchor='"+colourAnchor+"']");
        if (anchorColourRadio)
        {
            anchorColourRadio.checked = true;
            document.title = window.stripTags(anchorColourRadio.closest("label").getAttribute("title"))+" "+originalPageTitle;
        }
    }
    else
    {
        initialiseSwiper(); //we don't want to do this if we're changing the image anyway
    }

    let setVariantCallback = () => {};
    
    if (sizeAnchor)
    {
        setVariantCallback = () => { selectSizeByAnchor(sizeAnchor) };
    }

    colourRadios.forEach(colourRadio => {
        colourRadio.addEventListener('change',() => {
            changeSelectedColour(colourRadio.value);
        });
        if (colourRadio.checked)
        {
            selectedColourId = colourRadio.value;
            changeSelectedColour(colourRadio.value,true,true,setVariantCallback);
        }
    });

    //if hash changes manually, try and change the colour
    window.addEventListener('hashchange', function ()
    {
        let colourAnchor,sizeAnchor;
        [colourAnchor, sizeAnchor] = getColourAnchorAndSizeAnchor();

        // console.log("hash change",colourAnchor,sizeAnchor);
        
        let setVariantCallback = () => {};
        if (sizeAnchor)
        {
            setVariantCallback = () => { selectSizeByAnchor(sizeAnchor) };
            var sizeAnchorInput = sizeAndQuantitySelectors.querySelector(".quantity_selector_quantity_field[data-anchor='"+sizeAnchor+"']");
        }
        if (colourAnchor)
        {
            const colourRadioToSelect = document.querySelector("input.colour_swatch[data-anchor='"+colourAnchor+"']");
            if ((colourRadioToSelect && !colourRadioToSelect.checked)
                ||
                (typeof(sizeAnchor) != "undefined" && sizeAnchorInput && sizeAnchorInput.value == "0")
            )
            {
                // console.log("passed",setVariantCallback);
                colourRadioToSelect.checked = true;
                changeSelectedColour(colourRadioToSelect.value,true,false,setVariantCallback);
            }
            else
            {
                // console.log("colour change not required",colourRadioToSelect);
            }
        }
    });

    //size and quantity selectors

    sizeAndQuantitySelectors.addEventListener('click',(event) => {
        if (event.target)
        {
            if (event.target.classList.contains('alternatives_link'))
            {
                event.preventDefault();
                window.richModal("<p>Alternative products list to appear here.</p>","Alternative Products");
            }
        }
    });

    sizeAndQuantitySelectors.addEventListener('change',(event) => {
        if (event.target)
        {
            if (event.target.classList.contains('quantity_selector_quantity_field'))
            {
                const quantityField = event.target;
                const sizeQuantitySelector = quantityField.closest(".size_quantity_selector");
                updateStickyAddToBasket();
                if (quantityField.value < 1)
                {
                    sizeQuantitySelector.classList.remove("active");
                }
                else
                {
                    sizeQuantitySelector.classList.add("active");
                }
            }
        }
    });

    const initialQuantityFields = sizeAndQuantitySelectors.querySelectorAll(".quantity_selector_quantity_field");
    initialQuantityFields.forEach(input => {
        input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    clearActivePriceBreak();

    const chooseSizeAndQuantityLink = document.querySelector(".choose_message");

    chooseSizeAndQuantityLink.addEventListener('click',(event)=>
    {
        event.preventDefault();
        window.scrollToElement("#size_and_quantities");
    });

    const stickyAddToBasketButton = document.getElementById("sticky_add_to_basket_button");

    stickyAddToBasketButton.addEventListener("click",(e)=>
    {
        const variant_quantity_inputs = document.querySelectorAll(".size_and_quantity_selectors input[type=number]");
        e.preventDefault();
        let data = [];
        variant_quantity_inputs.forEach(variant_quantity_input => {
            if (variant_quantity_input.value > 0)
            {
                data.push({"variant_id": parseInt(variant_quantity_input.name), "quantity": parseInt(variant_quantity_input.value)});
            }
        });

        const token = document.querySelector("meta[name=csrf-token]").getAttribute("content");
        const url = document.getElementById("product_page_form").getAttribute("action");

        stickyAddToBasketButton.classList.add("loading");
        stickyAddToBasketButton.disabled = true;
        
        fetch(url,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': token
            },
            body: JSON.stringify(data)
        })
        .then(response => response.json())
        .then(result => 
        {
            if (result.success)
            {
                if (typeof datalayerEvent === 'function') {
                    datalayerEvent({
                        event: 'add_to_cart',
                        products: result.data_layer.items,
                        total: result.data_layer.value,
                        currency: result.data_layer.currency
                    });
                }
                let message_html = "<div class='added_products'>";
                
                message_html+= "<div class='added_product'><img src='"+result.thumb+"' alt='"+result.product_name+"' />";
                message_html+= "<div><strong>"+result.product_name+"</strong><br />"+result.colour+"<br /><strong>"+result.size_and_quantity+"</strong></div></div>";
                
                message_html+= "</div>";

                let button_label = "View Basket";
                let button_url = document.querySelector(".mini_basket_container .nav_link").getAttribute("href");
                if (result.hasOwnProperty("customisation_route"))
                {
                    button_label = "Add Logo";
                    button_url = result.customisation_route;
                }

                window.basketMessage("Added to Basket",message_html,button_url,button_label);
                stickyAddToBasketButton.classList.add("success");
                setTimeout(() => {
                    stickyAddToBasketButton.classList.remove("success");
                }, 1000);

                basketProductQty += data.reduce((sum, item) => sum + item.quantity, 0);

                if (result.basket_item_count !== undefined) {
                    deliveryBasketState.count       = result.basket_item_count;
                    deliveryBasketState.totalExVat  = result.basket_total_ex_vat  ?? deliveryBasketState.totalExVat;
                    deliveryBasketState.totalIncVat = result.basket_total_inc_vat ?? deliveryBasketState.totalIncVat;
                }
                updateFreeDeliveryMessage(0, false, false);

                suppressDeliveryMessageUpdate = true;
                const quantityFields = document.querySelectorAll(".size_and_quantity_selectors .quantity_selector_quantity_field");
                quantityFields.forEach(input => {
                    input.value = 0;
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                });
                suppressDeliveryMessageUpdate = false;
                if (result.basket_item_count)
                {
                    const basket_item_count = document.querySelector(".mini_basket_container .nav_link.basket .count");
                    basket_item_count.innerHTML = result.basket_item_count;
                    basket_item_count.classList.add('visible');
                }
            }
            else
            {
                let error = "We could not add your selection to your basket. Please try again, or make another selection.";
                if (result.error)
                {
                    error = result.error
                }
                window.basketError("Sorry",error);
                stickyAddToBasketButton.disabled = false;
            }

            stickyAddToBasketButton.classList.remove("loading");
            
        })
        .catch(error => {
            window.basketError("Sorry",error);
            stickyAddToBasketButton.classList.remove("loading");
            stickyAddToBasketButton.disabled = false;
        });
    });

    document.querySelector('.price_break_list')?.addEventListener('click', (e) => {
        const msg = e.target.closest('.price_break_proximity_message');
        if (msg) msg.innerHTML = '';
    });

    document.getElementById('price_breaks_vat_switch')?.addEventListener('change', () => {
        document.querySelectorAll('.price_break_proximity_message').forEach(msg => msg.innerHTML = '');
    });

    const priceTypeSelector = document.querySelector("select.price_type");

    priceTypeSelector.addEventListener("change",(e)=>
    {
        const allPriceBreaks = document.querySelectorAll(".price_break_list li");
        allPriceBreaks.forEach(priceBreak => {
            if (priceBreak.classList.contains(priceTypeSelector.value))
            {
                priceBreak.classList.remove("hidden");
            }
            else
            {
                priceBreak.classList.add("hidden");
            }
        });
        clearActivePriceBreak();
        updateLastVisibleBreakClass();
        updateStickyAddToBasket();
    });

    updateLastVisibleBreakClass();
});